
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sso-callback",
      function () {
        return require("private-next-pages/sso-callback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sso-callback"])
      });
    }
  